var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Endpoints } from '@brg/api';
var getMeta = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var img;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                img = new Image();
                img.src = url;
                return [4 /*yield*/, img.decode()];
            case 1:
                _a.sent();
                return [2 /*return*/, {
                        width: img === null || img === void 0 ? void 0 : img.naturalWidth,
                        height: img === null || img === void 0 ? void 0 : img.naturalHeight,
                        ratio: (img === null || img === void 0 ? void 0 : img.naturalWidth) / (img === null || img === void 0 ? void 0 : img.naturalHeight)
                    }];
        }
    });
}); };
var getOriginals = function (attachment) {
    var _a, _b, _c;
    var original = ((_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.size) === 'original'; })) || [];
    if ((original === null || original === void 0 ? void 0 : original.length) === 0 && ((_b = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        return attachment === null || attachment === void 0 ? void 0 : attachment.files;
    }
    if (((_c = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _c === void 0 ? void 0 : _c.length) === 0 || !(attachment === null || attachment === void 0 ? void 0 : attachment.files)) {
        return [];
    }
    return original;
};
export var fixUnsizedImages = function (attachments) { return __awaiter(void 0, void 0, void 0, function () {
    var originalAttachments, promises;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                originalAttachments = ((_a = (attachments || [])) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { return (__assign(__assign({}, attachment), { files: getOriginals(attachment) })); })) || [];
                return [4 /*yield*/, (originalAttachments === null || originalAttachments === void 0 ? void 0 : originalAttachments.map(function (attachment) { return __awaiter(void 0, void 0, void 0, function () {
                        var newFiles, meta;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    newFiles = [];
                                    if (!(((_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.length) > 0)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, getMeta(Endpoints.files + '/' + ((_b = attachment === null || attachment === void 0 ? void 0 : attachment.files[0]) === null || _b === void 0 ? void 0 : _b.url))];
                                case 1:
                                    meta = _c.sent();
                                    newFiles.push(__assign(__assign({}, attachment === null || attachment === void 0 ? void 0 : attachment.files[0]), meta));
                                    _c.label = 2;
                                case 2: return [2 /*return*/, __assign(__assign({}, attachment), { files: newFiles })];
                            }
                        });
                    }); }))];
            case 1:
                promises = _b.sent();
                return [4 /*yield*/, Promise.all(promises)];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
export var isUnsizedImages = function (attachments) {
    return ((attachments === null || attachments === void 0 ? void 0 : attachments.some(function (attachment) {
        var _a;
        return (_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.some(function (file) { return (file === null || file === void 0 ? void 0 : file.width) === 0 || (file === null || file === void 0 ? void 0 : file.height) === 0 || (file === null || file === void 0 ? void 0 : file.ratio) === 0; });
    })) || false);
};
export var hasOnlyOriginals = function (attachments) {
    var _a;
    return Boolean((_a = (attachments || [])) === null || _a === void 0 ? void 0 : _a.every(function (attachment) {
        var _a;
        return (_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.every(function (file) { return (file === null || file === void 0 ? void 0 : file.size) === "original"; });
    }));
};
//# sourceMappingURL=fixUnsizedImages.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Endpoints } from '@brg/api';
var getMeta = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var img;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                img = new Image();
                img.src = url;
                return [4 /*yield*/, img.decode()];
            case 1:
                _a.sent();
                return [2 /*return*/, {
                        width: img === null || img === void 0 ? void 0 : img.naturalWidth,
                        height: img === null || img === void 0 ? void 0 : img.naturalHeight,
                        ratio: (img === null || img === void 0 ? void 0 : img.naturalWidth) / (img === null || img === void 0 ? void 0 : img.naturalHeight)
                    }];
        }
    });
}); };
var getOriginals = function (attachment) {
    var _a, _b, _c;
    var original = ((_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.size) === 'original'; })) || [];
    if ((original === null || original === void 0 ? void 0 : original.length) === 0 && ((_b = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        return attachment === null || attachment === void 0 ? void 0 : attachment.files;
    }
    if (((_c = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _c === void 0 ? void 0 : _c.length) === 0 || !(attachment === null || attachment === void 0 ? void 0 : attachment.files)) {
        return [];
    }
    return original;
};
export var fixUnsizedImages = function (attachments) { return __awaiter(void 0, void 0, void 0, function () {
    var originalAttachments, promises;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                originalAttachments = ((_a = (attachments || [])) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { return (__assign(__assign({}, attachment), { files: getOriginals(attachment) })); })) || [];
                return [4 /*yield*/, (originalAttachments === null || originalAttachments === void 0 ? void 0 : originalAttachments.map(function (attachment) { return __awaiter(void 0, void 0, void 0, function () {
                        var newFiles, meta;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    newFiles = [];
                                    if (!(((_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.length) > 0)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, getMeta(Endpoints.files + '/' + ((_b = attachment === null || attachment === void 0 ? void 0 : attachment.files[0]) === null || _b === void 0 ? void 0 : _b.url))];
                                case 1:
                                    meta = _c.sent();
                                    newFiles.push(__assign(__assign({}, attachment === null || attachment === void 0 ? void 0 : attachment.files[0]), meta));
                                    _c.label = 2;
                                case 2: return [2 /*return*/, __assign(__assign({}, attachment), { files: newFiles })];
                            }
                        });
                    }); }))];
            case 1:
                promises = _b.sent();
                return [4 /*yield*/, Promise.all(promises)];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}); };
export var isUnsizedImages = function (attachments) {
    return ((attachments === null || attachments === void 0 ? void 0 : attachments.some(function (attachment) {
        var _a;
        return (_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.some(function (file) { return (file === null || file === void 0 ? void 0 : file.width) === 0 || (file === null || file === void 0 ? void 0 : file.height) === 0 || (file === null || file === void 0 ? void 0 : file.ratio) === 0; });
    })) || false);
};
export var hasOnlyOriginals = function (attachments) {
    var _a;
    return Boolean((_a = (attachments || [])) === null || _a === void 0 ? void 0 : _a.every(function (attachment) {
        var _a;
        return (_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.every(function (file) { return (file === null || file === void 0 ? void 0 : file.size) === "original"; });
    }));
};
//# sourceMappingURL=fixUnsizedImages.js.map